import { render } from "./MyTips.vue?vue&type=template&id=c93d71ca&scoped=true"
import script from "./MyTips.vue?vue&type=script&lang=js"
export * from "./MyTips.vue?vue&type=script&lang=js"

import "./MyTips.vue?vue&type=style&index=0&id=c93d71ca&lang=scss&scoped=true"
import "./MyTips.vue?vue&type=style&index=1&id=c93d71ca&lang=scss"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c93d71ca"]])

export default __exports__